import { SelectedItemsContext } from './Contexts';
import { useContext } from 'react';
export default function useSelectedItems(){

  return useContext(SelectedItemsContext);

}
